import { createContext, useMemo } from 'react'

import { authClient, clearBearerToken, type AuthSession } from '@/clients/auth'

interface AuthContextType {
  session: AuthSession['session'] | null
  user: AuthSession['user'] | null
  loading: boolean
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType>({
  session: null,
  user: null,
  loading: true,
  logout: async () => {},
})

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data, isPending } = authClient.useSession()

  const value = useMemo(
    () => ({
      session: data?.session ?? null,
      user: data?.user ?? null,
      loading: isPending,
      logout: async () => {
        try {
          await authClient.signOut()
        } finally {
          clearBearerToken()
        }
      },
    }),
    [data?.session, data?.user, isPending]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
